(function () {
  'use strict';
  if (window.flaskLocalStoreAnalyticsBound) return;
  window.flaskLocalStoreAnalyticsBound = true;

  const stores = [
    { id: 'studio_city_west', phone: '8187615373', maps: ['ZgiQx6FQqQ4c71Ug8'], handle: 'flask-studio-city-west' },
    { id: 'studio_city_east', phone: '8187665272', maps: ['Gq9T9NZFj6MkkYcg9'], handle: 'flask-studio-city-east' },
    { id: 'highland_park', phone: '3233815553', maps: ['zbdvyDUfr7PH9Nu76'], handle: 'flask-highland-park' }
  ];

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function' || !privacy.analyticsProcessingAllowed()) return;

    const link = event.target.closest('a[href]');
    let eventName;
    let store;
    if (link) {
      const url = new URL(link.href, window.location.origin);
      if (url.protocol === 'tel:') {
        const phone = url.pathname.replace(/\D/g, '').replace(/^1(?=\d{10}$)/, '');
        store = stores.find(item => item.phone === phone);
        if (store) eventName = 'local_call_click';
      } else if (url.hostname === 'maps.app.goo.gl') {
        store = stores.find(item => item.maps.includes(url.pathname.slice(1)));
        if (store) eventName = 'local_directions_click';
      } else if (url.hostname === 'www.google.com' && url.pathname.startsWith('/maps/dir/')) {
        store = stores.find(item => window.location.pathname === '/pages/' + item.handle);
        if (store) eventName = 'local_directions_click';
      }
    }
    // The existing Find in-store control shows all stores. It is not a pickup selection.
    if (!eventName && event.target.closest('[data-section-type="store-availability"] tool-tip-trigger')) {
      eventName = 'local_pickup_availability_open';
    }
    if (!eventName) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      store_id: store ? store.id : 'all_stores',
      local_page_path: window.location.pathname,
      local_interaction_surface: event.target.closest('[data-store-availability-holder]') ? 'product_availability' : 'page'
    });
  }, true); // The existing tooltip stops click propagation at its trigger.
})();
